import { useEffect, useState } from 'react';
import { message } from 'antd';
import moment from 'moment';
import { FinancesOrderView, PaymentType } from 'types';
import { useClients } from 'reducers';
import API from '../../API';

export const useFinances = () => {
	const clients = useClients({});
	const [orders, setOrders] = useState<FinancesOrderView[]>();

	const [from, setFrom] = useState<moment.Moment>(moment().startOf('month'));
	const [to, setTo] = useState<moment.Moment>(moment().endOf('month'));
	const [clientId, setClientId] = useState<number | undefined>();
	const [paid, setPaid] = useState<boolean | undefined>();
	const [paymentType, setPaymentType] = useState<PaymentType | undefined>();

	const fetchData = async () => {
		try {
			const data = await API.orders2.finances.get({
				after: from.hours(0).minutes(0).seconds(0),
				before: to.hours(23).minutes(59).seconds(59),
				client_id: clientId,
				paid,
				payment_type: paymentType,
			});

			setOrders(data);
		} catch (e) {
			console.trace(e);
			message.error(`${e}`);
		}
	};

	useEffect(() => {
		fetchData();
	}, [from.unix(), to.unix(), clientId, paid, paymentType]);

	const clearFilters = () => {
		setFrom(moment().startOf('month'));
		setTo(moment().endOf('month'));
		setClientId(undefined);
		setPaid(undefined);
		setPaymentType(undefined);

		fetchData();
	};

	return {
		clients,
		orders,
		from,
		to,
		clientId,
		paid,
		paymentType,
		fromChanged: setFrom,
		toChanged: setTo,
		clientIdChanged: setClientId,
		paidChanged: setPaid,
		paymentTypeChanged: setPaymentType,
		clearFilters,
	};
};
